module.exports = __webpack_public_path__ + "static/media/JR MPC(20-06-2026).87ecd220.xlsx";